import { format, parseISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

import { DateFormatsEnum } from '../constants/date';
import { isValidDate } from './date';

export const BULK_SEND_TITLE_SEPARATOR = ' - ';

export interface IBulkSendTitleParts {
  campaignName: string;
  recipientCount: number;
}

const formatRecipientCount = (count: number): string => `${count} ${count === 1 ? 'recipient' : 'recipients'}`;

export const buildBulkSendTitle = ({ campaignName, recipientCount }: IBulkSendTitleParts): string =>
  [campaignName.trim(), formatRecipientCount(recipientCount)].filter(Boolean).join(BULK_SEND_TITLE_SEPARATOR);

const LEGACY_TITLE_TIMESTAMP = / - \d{2} [A-Za-z]{3} \d{4} \d{2}:\d{2}$/;

export const stripLegacyBulkSendTimestamp = (title: string): string => title.replace(LEGACY_TITLE_TIMESTAMP, '');

export const buildBulkSendRowTitle = (title: string, createdAt: string, timeZone: string): string => {
  const base = stripLegacyBulkSendTimestamp(title.trim());
  const created = parseISO(createdAt);
  const createdDate = isValidDate(created) ? format(toZonedTime(created, timeZone), DateFormatsEnum.ddMMMyyyy) : '';

  return [base, createdDate].filter(Boolean).join(BULK_SEND_TITLE_SEPARATOR);
};
